export default {
  install(Vue, options) {
    Object.defineProperty(Vue.prototype, '$profile', {
      get() {
        return this.$store.getters['profiles/currentProfile']
      }
    })
  }
}
